import { styled } from 'styled-components';

import { Image } from '@/shared/ui/image/Image';
import { Box } from '@/shared/ui/box/Box';
import { StyledAlertDialogContent } from '@/shared/ui/alert-dialog/styles';


const StyledKycVerificationDialogContent = styled(StyledAlertDialogContent)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 420px;
  padding: 18px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    width: 100%;
    height: 100dvh;
    max-height: calc(100dvh - 60px);
    border-radius: 0;
  }
`;

const Navigation = styled.nav`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s;
  background: #27262b;

  &:hover {
    opacity: 0.8;
  }
`;

const ButtonsContainer = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;

  & > button {
    flex: none;
  }

  @media (max-width: 768px) {
    .button-close {
      display: none;
    }
  }
`;

// Image
const LogoImage = styled(Image)`
  margin: auto;

  & img {
    width: ${({ width }) => width || '120px'};
    height: ${({ height }) => height || '120px'};
    aspect-ratio: 1/1;
  }
`;

const IconWrapper = styled.div`
  position: relative;
  margin: 0 auto;
  width: 120px;
  height: 120px;
`;

const StatusBadge = styled.span<{ $right: number }>`
  position: absolute;
  top: 10px;
  right: ${({ $right }) => $right}px;
  width: 33px;
  height: 33px;

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
`;

const StatusBadgeGlyph = styled.span`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Rubik', sans-serif;
  font-weight: 500;
  font-size: 20px;
  line-height: 1;
  color: #fff;
`;

const TextContent = styled.div`
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export {
  StyledKycVerificationDialogContent,
  Navigation,
  CloseButton,
  LogoImage,
  ButtonsContainer,
  IconWrapper,
  StatusBadge,
  StatusBadgeGlyph,
  TextContent,
};
